const addThousandDots = (integerValue: string): string =>
    integerValue.replace(/\B(?=(\d{3})+(?!\d))/g, ".");

export const formatNumberWithThousandSeparator = (value: number): string => {
    if (!Number.isFinite(value)) {
        return "";
    }

    const isNegative = value < 0;
    const absoluteValue = Math.abs(value);
    const [integerPart, decimalPart] = absoluteValue.toString().split(".");
    const groupedIntegerPart = addThousandDots(integerPart);
    const decimalSuffix = decimalPart ? `,${decimalPart}` : "";

    return `${isNegative ? "-" : ""}${groupedIntegerPart}${decimalSuffix}`;
};

const removeGroupingSeparators = (value: string): string => value.replace(/\./g, "");

export const parseFormattedNumber = (value: string): number | null => {
    const trimmedValue = value.trim();
    if (!trimmedValue) {
        return null;
    }

    const normalizedValue = removeGroupingSeparators(trimmedValue).replace(",", ".");
    const parsed = Number(normalizedValue);

    return Number.isNaN(parsed) ? null : parsed;
};

export const formatIntegerInput = (value: string): string => {
    const digitsOnly = value.replace(/\D/g, "");
    if (!digitsOnly) {
        return "";
    }

    const parsed = Number(digitsOnly);
    if (Number.isNaN(parsed)) {
        return "";
    }

    return formatNumberWithThousandSeparator(parsed);
};
